import { lazy } from "react";

const PropiedadesLayout = lazy(() => import("../../propiedades/PropiedadesLayout.jsx"));
const PropiedadesList = lazy(() => import("../../propiedades/Propiedades.jsx"));
const PropiedadForm = lazy(() => import("../../propiedades/PropiedadForm.jsx"));

const propiedadesRoutes = [
      {
            path: "propiedades",
            element: <PropiedadesLayout />,
            children: [
                  { index: true, element: <PropiedadesList /> },
                  { path: "nuevo", element: <PropiedadForm /> },
                  { path: "editar", element: <PropiedadForm /> },
            ],
      },
];

export default propiedadesRoutes;
